import { Directionality } from '@angular/cdk/bidi';
import { PortalInjector } from '@angular/cdk/portal';
import { Injectable, Provider, TemplateRef, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogContainer, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { CommonErrorHandlerModalComponent } from '../components/error.modal/common.error.handler.modal/common.error.handler.modal.component';
import { CommonErrorResponse, ErrorResponse } from '../components/error.modal/error.response';
import { UnsavedWarningModalComponent } from '../components/unsaved.warning.modal/unsaved.warning.modal.component';
import { WarningModalActions } from '../components/unsaved.warning.modal/warning.modal.actions';

@Injectable()
export class ModalService {

    public static modalConfiguration: MatDialogConfig = {
        width: '600px'
    };

    constructor(private dialog: MatDialog) {
    }

    public show<T>(config: {
        component: Type<T> | TemplateRef<T>, providers?: Provider[],
        panelClass?: string | string[], backdropClass?: string
    }) {
        let dialogRef = this.dialog.open(config.component,
            Object.assign({},
                ModalService.modalConfiguration,
                {
                    data: config.providers,
                    panelClass: config.panelClass,
                    backdropClass: config.backdropClass
                }));
        return dialogRef;
    }

    public showUnSaveWarning(actions: WarningModalActions) {
        if (!actions.keepWorking && !actions.discard && actions.allowNavigate) {
            actions.keepWorking = () => {
                actions.allowNavigate.next(false);
                actions.allowNavigate.complete();
            };

            actions.discard = () => {
                actions.allowNavigate.next(true);
                actions.allowNavigate.complete();
            };
        }

        this.show({
            component: UnsavedWarningModalComponent,
            providers: [{provide: WarningModalActions, useValue: actions}]
        });
    }

    public showErrorModal(message = 'Something went wrong!', okBtnText = 'OK') {
        this.show({
            component: CommonErrorHandlerModalComponent,
            providers: [{
                provide: CommonErrorResponse,
                useValue: new CommonErrorResponse(message, okBtnText)
            }]
        });
    }
}

export interface ModalRef {
    close(dialogResult?: any): void;

    afterOpen(): Observable<void>;

    afterClosed(): Observable<any>;

    beforeClose(): Observable<any>;

    backdropClick(): Observable<void>;
}

// Unpack MAT_DIALOG_DATA provider into separate providers
MatDialog.prototype['_createInjector'] = function <T>(config: MatDialogConfig,
                                                      dialogRef: MatDialogRef<T>,
                                                      dialogContainer: MatDialogContainer): PortalInjector {
    const userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
    const injectionTokens = new WeakMap();

    injectionTokens.set(MatDialogRef, dialogRef);
    injectionTokens.set(MatDialogContainer, dialogContainer);
    injectionTokens.set(MAT_DIALOG_DATA, config.data);

    if (!!(config.data)) {
        // Unpack
        for (let provider of config.data) {
            injectionTokens.set(provider.provide, provider.useValue);
        }
    }

    injectionTokens.set(Directionality, {
        value: config.direction,
        change: Observable.of
    });

    return new PortalInjector(userInjector || this._injector, injectionTokens);
};


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/modal.service.ts